import Layout from "../../../components/layout/layout.js";

import Chat from "../../../components/chatPage/index.js";

function ChatPage({ component, ...rest }) {
  return <Layout Component={Chat} controlsDisabled={true} {...rest} />;
}

export default ChatPage;
